import { Dropdown } from "react-bootstrap";
import { Button } from "userful-chronos-common-ui/dist";
import { ISortConstellations } from "../ConstellationsTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/pro-regular-svg-icons";

interface IProps {
    onSortChange: (sort: ISortConstellations) => void;
    sort: ISortConstellations;
}

export default function SortConstellations(props: IProps) {
    return (
        <>
            <Dropdown>
                <Dropdown.Toggle as={Button} className="userful-button-dropdown">
                    <p className="sort-p">Sort by</p>
                    <p>Name {props.sort.sort === "ASC" ? "Ascending" : "Descending"}</p>
                    <FontAwesomeIcon icon={faAngleDown} />
                </Dropdown.Toggle>

                <Dropdown.Menu className="userful-icon-dropdown-menu">
                    {["name", "name"].map((item, index) => {
                        return (
                            <Dropdown.Item
                                key={index}
                                onClick={(e) => {
                                    props.onSortChange({ element: item, sort: index % 2 === 0 ? "ASC" : "DESC" });
                                }}
                            >
                                <p>Name {index % 2 === 0 ? "Ascending" : "Descending"} </p>
                            </Dropdown.Item>
                        );
                    })}
                </Dropdown.Menu>
            </Dropdown>
        </>
    );
}
